import { Html } from '@change-corgi/design-system/html';
import { Box } from '@change-corgi/design-system/layout';
import { Heading, Text } from '@change-corgi/design-system/typography';

import { usePsfPromoteOrSharePageData } from 'src/app/pages/psf/promoteOrShare/pageContext';
import { usePageCopy } from 'src/app/pages/psf/promoteOrShare/shared/hooks';

export function ComboStory(): React.JSX.Element | null {
	const {
		data: { subheadingText2, subheadingText3, subheadingContributionHero, subheadingContributionNone },
	} = usePageCopy();

	const {
		data: {
			petition: { promotionStats },
		},
	} = usePsfPromoteOrSharePageData();

	const showImpactBox = promotionStats.signatureCount > 1;

	if (!subheadingText3) {
		return <Html as="div" html={subheadingText2} noContentStyles />;
	}

	return (
		<>
			<Heading as="h2" size="h3" mb={16}>
				{subheadingText2}
			</Heading>
			<Box sx={{ marginBottom: 16 }}>
				<Text>{subheadingText3}</Text>
			</Box>
			{showImpactBox && <Html html={subheadingContributionHero || subheadingContributionNone} mb={16} />}
		</>
	);
}
